import { createBaseApi, getAuthHeaders } from '../utils/baseApi';

const apiVersion = 'v1';

const { getJson, postJson, deleteJson, putJson } = createBaseApi(`/api/${apiVersion}`, { headers: getAuthHeaders });

export const listRequirementTemplateFolders = (companyId, pageData) => getJson(`/companies/${companyId}/requirement-template-folders`, pageData);

export const listRequirementTemplates = (companyId, pageData, filter, sort) => getJson(`/companies/${companyId}/requirement-templates`, pageData, { filter }, { sort });

export const getRequirementTemplate = templateId => getJson(`/requirement-templates/${templateId}`);
